import React from "react";
import { Badge } from "@/components/ui/badge";

export const FIT_TONE = {
  qualified: "bg-emerald-50 text-emerald-800 border-emerald-200",
  check_me: "bg-amber-50 text-amber-800 border-amber-200",
  screened_out: "bg-slate-100 text-slate-600 border-slate-200",
  not_applicable: "bg-slate-50 text-slate-500 border-slate-200",
};
export const FIT_LABEL = { qualified: "Qualified", check_me: "Check me", screened_out: "Screened out", not_applicable: "—" };
export const CATEGORIES = ["new_opportunity", "existing_pursuit", "paperwork", "internal", "vendor_or_supplier", "platform_notice", "recruiting", "personal", "automated", "spam"];
export const FITS = ["qualified", "check_me", "screened_out", "not_applicable"];
export const EVENTS = [
  "asked_for_price", "asked_question", "sent_documents", "sent_their_nda", "nda_returned_signed", "sent_prequal_form", "set_meeting", "price_feedback",
  "asked_revised_price", "shortlisted", "awarded", "lost", "on_hold", "cancelled", "acknowledged", "schedule_change", "status_update",
  "we_sent_price", "we_sent_revised_price", "we_asked_question", "we_sent_paperwork", "we_followed_up", "we_declined_scope", "we_declined_job", "we_confirmed_meeting",
  "internal_discussion", "none",
];
export const label = (s) => (s || "").replace(/_/g, " ");

export function FitBadge({ fit, testid }) {
  return <Badge variant="outline" className={`text-[10px] font-semibold ${FIT_TONE[fit] || FIT_TONE.not_applicable}`} data-testid={testid}>{FIT_LABEL[fit] || label(fit)}</Badge>;
}

export function Chip({ children, testid }) {
  return <span className="inline-flex items-center text-[11px] px-2 py-0.5 rounded-full bg-slate-100 text-slate-700 border border-slate-200" data-testid={testid}>{children}</span>;
}

export function Evidence({ items, testid }) {
  if (!items?.length) return null;
  return (
    <ul className="mt-2 space-y-1" data-testid={testid}>
      {items.slice(0, 4).map((e, i) => (
        <li key={i} className="text-xs text-slate-700 border-l-2 border-[#F4C400] pl-2">
          “{e.text}”{e.source ? <span className="text-slate-400"> — {e.source}</span> : null}
        </li>
      ))}
    </ul>
  );
}

export function Facts({ facts }) {
  if (!facts) return null;
  const rows = [["Project", facts.project_name], ["Client", facts.client_company], ["Owner", facts.owner_developer],
    ["Where", [facts.city, facts.county, facts.state].filter(Boolean).join(", ")], ["MW", facts.mwdc ? `${facts.mwdc} MWdc` : facts.mwac ? `${facts.mwac} MWac` : null],
    ["Scope", facts.scope], ["Due", facts.due_date], ["Start", facts.start_date], ["Price", facts.price_amount ? `$${Number(facts.price_amount).toLocaleString()}` : null],
    ["Contact", [facts.contact_name, facts.contact_email, facts.contact_phone].filter(Boolean).join(" · ")]].filter(([, v]) => v);
  if (!rows.length) return <div className="text-xs text-slate-400 mt-2">No facts stated in the email.</div>;
  return (
    <div className="mt-2 flex flex-wrap gap-1.5" data-testid="bd-facts">
      {rows.map(([k, v]) => <Chip key={k}><span className="text-slate-400 mr-1">{k}</span>{v}</Chip>)}
    </div>
  );
}
